import React from "react";
import { Link } from "react-router-dom";
import Paths from "../util/paths";
import Colors from "./colors";

class AbstractEntity {
  /**
   *
   * @param {object} obj
   * @param {UserInfo} userInfo
   */
  constructor(obj, userInfo) {
    this.obj = null;
    this.userInfo = null;
    this.colors = null;

    if (obj) {
      this.obj = obj;

      if (obj.colors) {
        this.colors = new Colors(obj.colors);
      }
    }

    if (userInfo) this.userInfo = userInfo;

    this.label = null;
    this.pathDeps = {};
    this.defaultPathName = "home";
  }

  /**
   *
   * @param {object} obj
   * @param {string} key
   * @returns {boolean}
   * @protected
   */
  _keyExists(obj, key) {
    return obj.hasOwnProperty(key);
  }

  /**
   *
   * @param {object} obj
   * @param {string} key
   * @param {string} [path]
   * @protected
   */
  _verifyKeyExists(obj, key, path) {
    if (!this._keyExists(obj, key)) {
      let msg = `Key "${key}" does not exist in path`;
      if (path) msg += `: ${path}`;
      throw new Error(msg);
    }
  }

  /**
   *
   * @param [args]
   * @returns {null|*}
   */
  getLabel(args) {
    return this.label;
  }

  /**
   *
   * @param {string} [label]
   * @returns {JSX.Element|null}
   */
  getLink(label) {
    if (!label) label = this.getLabel();
    return <Link to={this.getPath()}>{label}</Link>;
  }

  /**
   * @param {object} [injectProps={}]
   * @returns {?string}
   */
  getPath(injectProps = {}) {
    let paths = new Paths(this.pathDeps);
    return paths.get(this.defaultPathName, injectProps);
  }

  /**
   *
   * @returns {boolean}
   */
  hasColors() {
    return this.hasLoaded() && this.hasOwnProperty("colors") && !!this.colors;
  }

  /**
   *
   * @returns {boolean}
   */
  hasLoaded() {
    return !!this.obj && !!this.userInfo;
  }
}

export default AbstractEntity;
